export const extractFileName = (contentDispositionHeader: string, fallback: string) => {
    const encodedFilename = /filename\*=UTF-8''([^;\n]*)/i.exec(contentDispositionHeader)?.[1];
    if (encodedFilename) {
        try {
            return decodeURIComponent(encodedFilename);
        } catch {
            return fallback;
        }
    }
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDispositionHeader);

    if (matches === null || !matches[1]) {
        return fallback;
    }

    return matches[1].replace(/['"]/g, '');
};
